import { Link } from "react-router-dom";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Field, inputCls } from "../wizard/WizardSteps";
import { CONTACT_MOMENTS, MESSAGE_PLACEHOLDER } from "../../data/contact";

const Text = ({ id, label, form, set, errors, required, note, ...rest }) => (
  <Field id={`contact-${id}`} label={label} required={required} note={note} error={errors[id]}>
    <Input id={`contact-${id}`} value={form[id]} onChange={(e) => set(id, e.target.value)} aria-invalid={!!errors[id]} className={inputCls(errors[id])} data-testid={`contact-${id}`} {...rest} />
  </Field>
);

const Callback = ({ form, set }) => (
  <div className="rounded-2xl border border-slate-200 bg-slate-50/70 p-4">
    <label className="flex items-start gap-3 text-[15px] font-semibold text-ink">
      <input type="checkbox" checked={form.callback} onChange={(e) => set("callback", e.target.checked)} className="mt-1 h-4 w-4 accent-[#0E777D]" data-testid="contact-callback" />
      <span>Ik word liever gebeld <span className="font-normal text-slate-500">(optioneel)</span></span>
    </label>
    {form.callback && (
      <div className="mt-3 pl-7">
        <p className="text-[13.5px] font-semibold text-slate-700">Wanneer schikt het u?</p>
        <div className="mt-2 flex flex-wrap gap-2" role="radiogroup" aria-label="Voorkeursmoment" data-testid="contact-moments">
          {CONTACT_MOMENTS.map(([v, l]) => (
            <button key={v} type="button" role="radio" aria-checked={form.moment === v} onClick={() => set("moment", v)} data-testid={`contact-moment-${v}`}
              className={`rounded-full px-3 py-1.5 text-[13.5px] font-semibold transition-colors ${form.moment === v ? "bg-ink text-white" : "bg-white text-slate-600 ring-1 ring-slate-200 hover:bg-slate-100"}`}>{l}</button>
          ))}
        </div>
      </div>
    )}
  </div>
);

export const ContactFields = ({ topic, form, set, errors }) => (
  <div className="grid gap-4">
    <Text id="naam" label="Naam" required form={form} set={set} errors={errors} maxLength={100} autoComplete="name" placeholder="Voor- en achternaam" />
    <div className="grid gap-4 sm:grid-cols-2">
      <Text id="email" label="E-mailadres" required form={form} set={set} errors={errors} type="email" inputMode="email" maxLength={120} autoComplete="email" placeholder="naam@voorbeeld.nl" />
      <Text id="telefoon" label="Telefoonnummer" required={form.callback} form={form} set={set} errors={errors} type="tel" inputMode="tel" maxLength={20} autoComplete="tel" placeholder="06 12345678" />
    </div>
    {topic === "inmeten" && <Text id="woonplaats" label="Woonplaats" required form={form} set={set} errors={errors} maxLength={80} autoComplete="address-level2" placeholder="Bijv. Vlaardingen" />}
    <Field id="contact-bericht" label="Uw vraag of bericht" required error={errors.bericht}>
      <Textarea id="contact-bericht" rows={5} maxLength={2000} value={form.bericht} onChange={(e) => set("bericht", e.target.value)} aria-invalid={!!errors.bericht}
        placeholder={MESSAGE_PLACEHOLDER[topic]} className={`rounded-xl text-[15px] ${errors.bericht ? "border-red-400" : "border-slate-300"}`} data-testid="contact-bericht" />
    </Field>
    <Callback form={form} set={set} />
    <input type="text" name="website" tabIndex={-1} autoComplete="off" aria-hidden="true" value={form.website} onChange={(e) => set("website", e.target.value)} className="absolute -left-[9999px] h-0 w-0 opacity-0" />
    <p className="text-[13px] leading-relaxed text-slate-500">
      Wij gebruiken uw gegevens alleen om uw vraag te beantwoorden. Door te versturen gaat u akkoord met onze{" "}
      <Link to="/privacy" className="font-medium text-maas underline underline-offset-2" target="_blank">privacyverklaring</Link>.
    </p>
  </div>
);
